import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import FeatureWizardSelectionItem from "./featureWizardSelectionItem";

export default class FeatureWizardSelection extends Component {

  static propTypes = {
    toggleWizardFilterSelection: PropTypes.func.isRequired,
    getFilterValueObjectById: PropTypes.func.isRequired,
    onItemClick: PropTypes.func.isRequired,
    exitFeatureWizard: PropTypes.func.isRequired,
    setFeatureWizardStep: PropTypes.func.isRequired,
    currentStep: PropTypes.object.isRequired,
    isMobile: PropTypes.bool,
  };

  componentDidMount() {
    this.props.setFeatureWizardStep(0);
  }

  setWizardValue = (clickedFilterValue) => {
    this.props.toggleWizardFilterSelection(true);
    this.props.onItemClick(clickedFilterValue, false, this.props.currentStep.filterName);
    this.props.setFeatureWizardStep(1);
  };

  setAllItems = () => {
    setTimeout(() => {
      this.props.toggleWizardFilterSelection(true);
    }, 300);
    this.props.exitFeatureWizard();
  };

  render() {
    return (
      <div className={this.props.isMobile ? "menu-wizard" : "panel-filters"}>
        <ul className={"wiz-steps" + (this.props.isMobile ? " wiz-steps--full wiz-steps--selections" : "")}>
          <li className={"wiz-steps__item wiz-steps__item--all"}
              onClick={this.setAllItems}>
            <FormattedMessage id="filterSelection.allItems"/>
          </li>
          {this.props.currentStep.values.map((wizardValueObject, index) => {
            const currentFilterValue = this.props.getFilterValueObjectById(this.props.currentGroup, wizardValueObject.filterValue);
            return (
              <FeatureWizardSelectionItem
                key={"FeatureWizardSelectionItem"+index}
                currentFilterValue={currentFilterValue}
                setWizardValue={this.setWizardValue}/>
            )
          })}
        </ul>
      </div>
    )
  }
}
